import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation deleteSystemUiModule($id: String!) {
    deleteSystemUiModule(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const deleteSystemUiModuleRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_ui_module/delete_system_ui_module',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.deleteSystemUiModule;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const deleteSystemUiModuleSlice = createSlice({
  name: 'delete_system_ui_module',
  initialState: initialState,
  reducers: {
    deleteSystemUiModuleClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(deleteSystemUiModuleRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(deleteSystemUiModuleRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(deleteSystemUiModuleRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { deleteSystemUiModuleClear } =
deleteSystemUiModuleSlice.actions;

export const deleteSystemUiModule = createSelector(
  (state: RootState) => state.systemUiModule.deleteSystemUiModule.result,
  (state: RootState) => state.systemUiModule.deleteSystemUiModule.error,
  (state: RootState) => state.systemUiModule.deleteSystemUiModule.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default deleteSystemUiModuleSlice.reducer;